import { useFormikContext } from "formik";
import React from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import { Link } from "react-router-dom";

export const RequestSignupSubmission = () => {
    const { isSubmitting, status } = useFormikContext(); // use to disable button while the request is being made to server and to check for successful api call

    let statusMessage = "";

    if (status?.error === true) {
        statusMessage = <p role="status">Error sending verification email.</p>;
    } else if (status?.error === false) {
        statusMessage = (
            <p role="status" style={{ "fontSize": "1.2rem" }}>
                Sent a verification link associated with provided email.
                Please click the link in your email to activate your account. If
                you did not receive the link
                <Button
                    variant="link"
                    type="submit"
                    disabled={isSubmitting}
                    aria-label="Send Verification Email button"
                    aria-invalid={status?.error === true ? "true" : null}
                >
                    Click here to resend
                </Button>
            </p>
        );
    } else {
        statusMessage = "";
    }

    return (
        <>
            <Row>{statusMessage}</Row>
            {(status === undefined || status?.error === true) && (
                <Row>
                    <Col>
                        <Button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isSubmitting}
                            aria-label="Send Verification Email button"
                            aria-invalid={
                                status?.error === true ? "true" : null
                            }
                        >
                            Resend Email Verification
                        </Button>
                    </Col>
                    <Col>
                        <Row>
                            <Col className="d-flex justify-content-end">
                                <Link to="/signin" aria-label="Sign in link">
                                    Sign in
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            )}
        </>
    );
};
